// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import theme from '../../styled-components/dark';

const WINAMAX_TV_HEIGHT_CORRECTION = Target.__MOBILE__ ? 1.4 : 2;
const WINAMAX_TV_PADDING_CORRECTION = 0.3;

const IconWrapper = styled.div`
  & > * {
    height: ${Target.__MOBILE__ ? '2em' : '3em'};
    width: ${Target.__MOBILE__ ? '2em' : '3em'};
  }

  ${({ $isWinaTV }) => {
    if ($isWinaTV) {
      return css`
        & > * {
          height: ${WINAMAX_TV_HEIGHT_CORRECTION}em;
          padding-top: ${WINAMAX_TV_PADDING_CORRECTION}em;
        }
      `;
    }
  }}
`;

const Container = styled.div`
  padding: 0.1em 0;

  ${({ $isSelected, $isWinaTV }) => {
    if ($isWinaTV && $isSelected) {
      return css`
        box-shadow: ${Target.__MOBILE__ ? 'inset 50px 0px 5px black' : undefined};
        position: sticky;
        left: 0;
      `;
    }
  }}
`;

const StyledButton = styled.div`
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  border-radius: 150em;
  border: 1px solid;
  background: ${theme.MatchFilterItem.button.background.default};

  ${({ $isSelected, $isWinaTV }) => {
    if ($isWinaTV && $isSelected) {
      return css`
        border-color: ${theme.MatchFilterItem.button.border.fill};
        background: ${theme.MatchFilterItem.button.background.fill};
      `;
    }
    return $isSelected
      ? css`
          border-color: ${theme.MatchFilterItem.button.border.fill};
        `
      : css`
          border-color: ${theme.MatchFilterItem.button.border.default};
        `;
  }}

  cursor: pointer;
  width: 100%;
  height: ${Target.__MOBILE__ ? '2em' : '3em'};

  display: flex;
  align-items: center;
  justify-content: center;

  transition: none 150ms ease-in-out;
  transition-property: border, transform;

  &:active {
    transform: scale(0.95);
  }
`;

const Center = styled.div`
  width: 100%;
  padding: 0 0.5em;

  display: flex;
  align-items: center;
  justify-content: center;

  & > *:not(:last-child) {
    padding-right: 0.4em;
  }
`;

const Counter = styled.div`
  font-size: ${Target.__MOBILE__ ? '0.9em' : '1.2em'};
  color: ${({ $isWinaTV, $isSelected }) =>
    $isWinaTV && $isSelected ? theme.MatchFilterItem.count.fill : theme.MatchFilterItem.count.default};
`;

type Props = {
  className?: string;
  count: number;
  isSelected: boolean;
  icon: React.node;
  isWinaTV: boolean;
  onClick: () => void;
};

const MatchFilterItem = ({ className, count, isSelected, icon, onClick, isWinaTV = false }: Props) => {
  return (
    <Container className={className} $isSelected={isSelected} $isWinaTV={isWinaTV} onClick={onClick}>
      <StyledButton $isSelected={isSelected} $isWinaTV={isWinaTV}>
        <Center>
          <IconWrapper $isWinaTV={isWinaTV}>{icon}</IconWrapper>
          <Counter $isSelected={isSelected} $isWinaTV={isWinaTV}>
            {count}
          </Counter>
        </Center>
      </StyledButton>
    </Container>
  );
};

export default MatchFilterItem;
